import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'sportRoom',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  emptyMessage: "You don't have contents, visit the content section to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: true,
      canCreate: true,
      canOpen: true,
      helpText: 'Name of the content.',
    },
  ],
};
